export default "__VITE_ASSET__Jnr5WjqN__"